




































































import { Component, Vue } from 'vue-property-decorator';
import firebase from 'firebase/app';
import * as firebaseui from 'firebaseui';
import { firebaseAuth } from '../../server/init';
import usersDB from '../../server/init';
import slugify from 'slugify';
import axios from 'axios';

@Component({
  components: {},
})

export default class Signup extends Vue {
  private emailLogin: string | null = null;
  private passwordLogin: string | null = null;




  private email: string | null = null;
  private password: string | null = null;
  private username: string | null = null;
  private firstname: string | null = null;
  private lastname: string | null = null;
  private phone: string | null = null;
  private company: string | null = null;
  private address: string | null = null;
  private zip: string | null = null;
  private city: string | null = null;
  private state: string | null = null;
  private phoneType: string | null = null;
  private phoneCode: string | null = null;
  private investorType: string | null = null;
  private usernameError: string | null = null;
  private emailError: string | null = null;
  private passwordError: string | null = null;
  private firstnameError: string | null = null;
  private lastnameError: string | null = null;
  private phoneError: string | null = null;
  private zipError: string | null = null;
  private investorTypeError: string | null = null;
  private slugUser: string | null = null;


  private investor: any | null;
  private loginError: string | null = null;
  private displayLoginFields: boolean = true;
  private investorTypeLabel: boolean = true;
  private formValid: boolean = false;
  private formHeight: number = 1360;




  public data() {
    return {
      investorTypes: [
        {
          type: 'Private/Angel Investor',
          value: 'private-angel-investor',
        },
        {
          type: 'Private Equity',
          value: 'private-equity',
        },
        {
          type: 'Venture Fund',
          value: 'venture-fund',
        },
        {
          type: 'Investment Bank',
          value: 'investment-bank',
        },
        {
          type: 'Other',
          value: 'other',
        },
      ],
    };
  }

  private validateForm() {
    this.validateZip();
    this.validateInvestorType();
    this.validateEmail();
    this.validatePhone();
    if (!this.email) {
      this.emailError = 'Please enter a valid email.';
    } else {
      this.emailError = null;
    }
    if (!this.username) {
      this.usernameError = 'Please enter a username.';
    } else {
      this.usernameError = null;
    }
    if (!this.password || this.password.length < 6) {
      this.passwordError = 'Please enter a password that is at least 6 characters.';
    } else {
      this.passwordError = null;
    }
    if (!this.firstname) {
      this.firstnameError = 'Please enter your first name.';
    } else {
      this.firstnameError = null;
    }
    if (!this.lastname) {
      this.lastnameError = 'Please enter your last name.';
    } else {
      this.lastnameError = null;
    }
    return true;
  }

  private validateInvestorType() {
    if (!this.investorType) {
      this.investorTypeError = 'Please select an investor type.';
      this.formValid = false;
    } else {
      this.formValid = true;
      this.investorTypeError = null;
    }
  }

  private validateZip() {
    const req = `https://us-zipcode.api.smartystreets.com/lookup?&key=1039832244004341&zipcode=${this.zip}`;
    axios.get(req)
    .then((response) => {
      const resCity = response.data[0].city_states[0];
      if (resCity.mailable_city === true) {
        this.zipError = null;
        this.city = resCity.city;
        this.state = resCity.state;
      }
    })
    .catch((e) => {
      this.zipError = 'Please enter a valid zipcode.';
      this.formValid = false;
    });
  }

  private validatePhone() {
    const req = `http://apilayer.net/api/validate?access_key=25f34ea7d733d3b90c026094d33c167e&number=${this.phone}&country_code=US&format=1`;
    axios.get(req)
    .then((response) => {
      if (response.data.valid === true) {
        this.phone = response.data.number;
        this.phoneType = response.data.line_type;
        this.phoneCode = response.data.country_code;
        this.phoneError = null;
      } else {
        this.phoneError = 'Please enter a valid phone number with area code (U.S. Only).';
        this.formValid = false;
      }
    })
    .catch((e) => {
      console.log('phone error', e);
    });
  }

  private validateEmail() {
    const req = `http://apilayer.net/api/check?access_key=a75a3fbd530c74ac99b2d8c6b10568e5&email=${this.email}&smtp=1&format=1`;
    axios.get(req)
    .then((response) => {
      const res = response.data;
      if (res.format_valid === true && res.mx_found === true && res.smtp_check === true) {
        this.email = res.email;
        this.emailError = null;
      } else {
        this.emailError = 'Please enter a valid email address.';
        this.formValid = false;
      }
    })
    .catch((e) => {
      console.log('email error', e);
    });
  }

  private signup() {
   this.validateForm();
   if (this.username && this.password && this.email) {
     this.slugUser = slugify(this.username, {
     replacement: '-',
     remove: /[$*_+~.()'"!\-:@#]/g,
     lower: true,
    });
     const ref = usersDB.collection('users').doc(this.slugUser);
     ref.get().then((doc) => {
      if (doc.exists) {
        this.usernameError = 'Sorry this username is already taken. Please choose a different username.';
      } else {
        firebaseAuth.createUserWithEmailAndPassword(this.email, this.password)
        .then((cred) => {
          ref.set({
            username: this.username,
            user_id: cred.user.uid,
            investor: true,
            investorType: this.investorType,
            email: this.email,
            firstname: this.firstname,
            lastname: this.lastname,
            phone: this.phone,
            phoneType: this.phoneType,
            phoneCode: this.phoneCode,
            company: this.company,
            address: this.address,
            city: this.city,
            state: this.state,
          })
          .then(() => {
            this.$router.push('/business-plan');
          });
        })
        .catch((err) => {
          this.emailError = err.message;
        });
      }
    });
   }
  }


  private created() {
    firebaseAuth.onAuthStateChanged((user) => {
      user = firebaseAuth.currentUser;
      if (user) {
        this.displayLoginFields = false;
        usersDB.collection('users').where('user_id', '==', user.uid).get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.investor = doc.data();
            if (this.investor.investor) {
              return this.investor;
            } else {
              this.investor = null;
            }
          });
        });
      }
    });
  }
}
